<template>
  <ul-page class="page-virtual-grade" fullBody>
    <template v-slot:left>
      <div class="page-header-left">
        <div class="page-header-title">{{experimentName}}</div>
      </div>
    </template>
    <div class="page-content">
      <div class="sidebar">
        <div class="filters">
          <ul-select class="select-teacher" v-if="userInfoInCourse.permissionGroupId == 1" v-model="params.teacherId" @change="currentTeacherChange">
          <ul-option
              v-for="item in teacherList"
              :key="item.userId"
              :label="item.name"
              :value="item.userId">
            </ul-option>
          </ul-select>
          <ul-select class="select-class" v-model="params.classId" :popper-append-to-body="false"  @change="getFirstPage">
            <ul-option
              v-for="item in teacherClassList"
              :key="item.classId"
              :label="item.className"
              :value="item.classId">
            </ul-option>
          </ul-select>
          <ul class="student-list">
            <li v-for="item in studentList" :key="item.userId" :class="{'active': item.loginName == currentLoginName}" @click="changeStudent(item)">
              <div class="name">{{ item.userName }}</div>
              <div class="no">{{ item.studentId }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="page-main">
        <iframe id="iframe" frameborder="0"></iframe>
      </div>
    </div>
  </ul-page>
</template>

<script>
import {
  experimentScoreDetails,
  getExperimentInfo,
  getVirtualGradeList,
  getTonglabTicket
} from '@/api/courseApi/virtual.js'
import { getUserOcRole, getOcTeacherClassList } from '@/api/courseApi'
import { mapGetters } from 'vuex'
import { formatDate, formatSeconds } from '@/utils'
import experimentDetail from './experimentDetail.vue'
import { TONGLAB_WEB_HOST } from '@/config'
export default {
  name: 'page-virtual-grade',
  data () {
    return {
      userInfoInCourse: {},
      params: {
        teacherId: -1,
        classId: -1,
        ps: 10,
        pn: 1
      },
      teacherList: [{
        userId: -1,
        name: "全部教师",
        classes: [{
          classId: -1,
          className: "全部班级",
        }]
      }],
      experimentName: '',
      studentList: [],
      currentLoginName: '',
      ticket: '',
      currentStudent: {}
    }
  },
  computed: {
    ...mapGetters({ user: 'user/user' }),
    ocId () {
      return this.$route.query.ocId
    },
    experimentId () {
      return this.$route.params.id
    },
    courseSchedId () {
      return this.$route.query.courseSchedId
    },
    teacherClassList () {
      for (let i = 0; i < this.teacherList.length; i++) {
        const tea = this.teacherList[i];
        if (tea.userId == this.params.teacherId) {
          return tea.classes
        }
      }
      return []
    },
    iframeUrl () {
      return `${TONGLAB_WEB_HOST}/#/nolayout-wenhua/teach-project?courseSchedId=${this.courseSchedId}&stuUsername=${this.currentLoginName}&ticket=${this.ticket}`
    }
  },
  watch: {
    iframeUrl: {
      handler(newVal) {
        document.getElementById('iframe').src = ''
        document.getElementById('iframe').src = newVal
      },
      // immediate: true
    }
  },
  created () {
    window.test = this
    this.params.teacherId = this.$route.query.teacherId
    this.params.classId = this.$route.query.classId
    this.currentLoginName = this.$route.query.loginName
    getUserOcRole(this.ocId)
      .then(result => {
        this.userInfoInCourse = result
        this.getTeacherList()
      })

    getExperimentInfo({experimentId: this.experimentId})
    .then(({result}) => {
      this.experimentName = result.title
    })

    getTonglabTicket()
      .then(({result}) => {
        this.ticket = result
      })
  },  
  methods: {
    getScoreDetails() {
      experimentScoreDetails({recordId: this.formRow.recordId })
      .then(({result}) => {
        this.form = result
      })
    },
    isClassInList (item,list) {
      for (let i = 0; i < list.length; i++) {
        const ele = list[i];
        if (item.classId == ele.classId) {
          return true
        }
      }
      return false
    },
    getTeacherList () {
      getOcTeacherClassList(this.ocId)
        .then((result) => {
          this.teacherList = []
          let allClassList = []
          result.list.forEach(item => {
            if (item.classes.length > 0) {
              this.teacherList.push(item)
              for (let i = 0; i < item.classes.length; i++) {
                const cl = item.classes[i]
                if (!this.isClassInList(cl, allClassList)) {
                  allClassList.push(cl)
                }
              }
            }
          })
          this.teacherList.unshift({
            userId: -1,
            name: "全部教师",
            classes: allClassList
          })
          this.teacherList.forEach(item => {
            item.classes.unshift({
              classId: -1,
              className: "全部班级",
            })
          })
           this.params.teacherId = this.userInfoInCourse.userId
            if (this.teacherClassList.length == 0) {
              this.params.teacherId = -1
            }
            this.currentTeacherChange()
        })
    },
    currentTeacherChange () {
      this.params.classId = -1
      this.params.pn = 1
      this.getGradeList()
    },
    getFirstPage () {
      this.params.pn = 1
      this.getGradeList()
    },
    getGradeList () {
      let params = {...this.params}
      params.experimentId = this.experimentId
      params.ocId = this.ocId
      params.teacherId = params.teacherId === -1 ? undefined : params.teacherId
      params.classId = params.classId === -1 ? undefined : params.classId
      params.status = params.status || undefined
      getVirtualGradeList(params)
        .then(({result}) => {
          this.studentList = result.list.filter((item)=> item.status != 3)
        })
    },
    changeStudent (item) {
      this.currentLoginName = item.loginName 
    }
  },
  filters: {
    duration (time) {
      return formatSeconds(time) || '--'
    },
    formatDate (time) {
      return formatDate(time) || '--'
    }
  },
  components: {
    experimentDetail
  }
}
</script>

<style lang="scss" scoped>
.page-content{
  display: flex;
  height: calc(100vh - 50px);
}
.page-main{
  flex: 1;
  padding: 20px 0;
  iframe{
    width: 100%;
    height: 100%;
  }
}
.page-title{
  padding-bottom: 20px;
  border-bottom: $--border-dashed;
  font-size: 16px;
  font-weight: 600;
}
.sidebar{
  width: 281px;
  height: 100%;
  border-right: solid 1px $--border-color-base;
  background-color: $--background-color-base;
  .select-teacher{
    width: 130px;
    border-right: solid 1px $--border-color-base;
    border-bottom: solid 1px $--border-color-base;
  }
  .select-class{
    width: 150px;
    border-bottom: solid 1px $--border-color-base;
  }
  ::v-deep{
    .ul-input__inner{
      height: 48px;
      border-radius: 0;
      border: none;
      line-height: 48px;
      background-color: $--background-color-base;
    }
  }
}
.student-list{
  background-color: $--background-color-base;
  li{
    padding: 9px 24px;
    cursor: pointer;
    border-left: solid 5px transparent;
    .name{
      font-weight: 600;
    }
    .no{
      font-size: 12px;
      line-height: 18px;
      color: $--color-text-secondary;
    }
    &:hover{
      background-color: $--color-white;
    }
    &.active{
      background-color: $--color-white;
      border-color: $--color-primary;
    }
  }
}

</style>